module.exports = __webpack_public_path__ + "img/IMAGE3MESINVARNISH.1dbff843.jpeg";